var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1 mt-4",attrs:{"headers":_vm.headers,"items":_vm.usersData,"locale":"tr-TR","footer-props":{
    'items-per-page-options': [10, 20, 30, 40, 50],
  },"items-per-page":40,"item-class":_vm.itemRowBackground},scopedSlots:_vm._u([{key:"item.indexes",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.usersData .map(function (x) { return x.id; }) .indexOf(item.id) + 1)+". ")]}},{key:"item.photo",fn:function(ref){
  var item = ref.item;
return [_c('v-avatar',{attrs:{"size":"30","color":"success","dark":""}},[_c('v-img',{attrs:{"src":item.photo}})],1)]}},{key:"item.name",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(item.name)+" "),_c('span',{staticClass:"text-caption google-sans-regular"},[_vm._v(" #"+_vm._s(item.id.substring(item.id.length - 4))+" ")])]}},{key:"item.dtb",fn:function(ref){
  var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor('dtb')}},[_vm._v(" "+_vm._s(item.dtb))])]}},{key:"item.flt",fn:function(ref){
  var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor('flt'),"dark":""}},[_vm._v(" "+_vm._s(item.flt)+" ")])]}},{key:"item.iot",fn:function(ref){
  var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor('iot')}},[_vm._v(" "+_vm._s(item.iot)+" ")])]}},{key:"item.mcl",fn:function(ref){
  var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor('mcl'),"dark":""}},[_vm._v(" "+_vm._s(item.mcl)+" ")])]}},{key:"item.qtc",fn:function(ref){
  var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor('qtc'),"dark":""}},[_vm._v(" "+_vm._s(item.qtc)+" ")])]}},{key:"item.gen",fn:function(ref){
  var item = ref.item;
return [_c('v-chip',{attrs:{"color":"success","dark":""}},[_vm._v(" "+_vm._s(item.gen)+" ")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }